import type { FC } from "react";
import classNames from "classnames";

export const RegionalReviewCountryFlag: FC<{ countryCode: string }> = ({
  countryCode,
}) => (
  <span
    className={classNames(
      "fflag",
      `fflag-${countryCode}`,
      "ff-round reviews_regional_card_country_flag"
    )}
  />
);
